import {_} from 'lodash';
import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {ObjectTypeId} from "../../../constants";
import {IMessageData} from "../../../index";
import objectsHtml from './objects.html?raw';

export let template = objectsHtml;

interface IParams {
    addrecipient: KnockoutObservable<string>
}

export class viewModel {
    private ObjectTypeId = ObjectTypeId;
    private arr: KnockoutObservableArray<string>;
    private kosub = new KOSubscriptionTracker();
    constructor(private params: IParams) {
        const val = (!!params.addrecipient() ? params.addrecipient().split(','): []).filter(id => !isNaN(Number(id)));
        this.arr = ko.observableArray(val);
        this.kosub.subscribe(this.arr, arr => {
            const uniq = _.uniq(arr);
            this.params.addrecipient(uniq.join(','))
        });
    }

    private onRemove(id: string) {
        this.arr.remove(id);
    }

    private catchError(reason: string): IMessageData {
        return {
            message: 'Invalid object',
            type: 'danger',
        }
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
